export default __webpack_public_path__ + "static/media/portfolio.13bf5191.png";